import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { SealCheck, WarningCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/contexts/LanguageContext";
import { ScaledCertificate } from "@/components/exam/Certificate";

export default function CertificatePage() {
  const { id } = useParams();
  const { lang } = useTranslation();
  const es = lang === "es";
  const [cert, setCert] = useState(undefined);

  useEffect(() => {
    axios.get(`/api/certificates/${id}`).then((r) => setCert(r.data)).catch(() => setCert(null));
  }, [id]);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-6" data-testid="certificate-page">
      {cert === undefined && <p className="text-[#71717A]">{es ? "Cargando..." : "Loading..."}</p>}
      {cert === null && (
        <div className="flex items-center gap-3 bg-[#121214] border border-white/10 rounded-xl p-5" data-testid="certificate-not-found">
          <WarningCircle weight="fill" className="w-6 h-6 text-[#F5A524]" />
          <p className="text-[#A1A1AA]">{es ? "No encontramos este certificado." : "We couldn't find this certificate."}</p>
        </div>
      )}
      {cert && (
        <>
          <div className="flex items-center gap-2 text-emerald-400" data-testid="certificate-verified">
            <SealCheck weight="fill" className="w-6 h-6" />
            <p className="font-medium">
              {es ? "Certificado verificado por DSLR Advisor" : "Certificate verified by DSLR Advisor"}
            </p>
          </div>
          <ScaledCertificate cert={cert} lang={lang} />
          <div className="flex items-center gap-3 flex-wrap">
            <p className="text-[#A1A1AA] text-sm">
              {es ? "¿Quieres aprender fotografía manual tú también?" : "Want to learn manual photography too?"}
            </p>
            <Link to="/login">
              <Button className="bg-[#F5A524] text-[#0A0A0A] hover:bg-[#F5B041] font-medium" data-testid="certificate-cta">
                {es ? "Empieza gratis con DSLR Advisor" : "Start free with DSLR Advisor"}
              </Button>
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
